import { ThermalHotspot } from "~/pages/copilotMessage/types/copilot";

export interface GetProcessedImagesQuery {
  campaignHeatId: string;
  setId: string;
}

export enum IRImageType {
  West = 0,
  East = 1,
  North = 2,
}

export interface ThermalImagesZoneBoundaryInfo {
  Height: number;
  Width: number;
  HorizontalLines: ZoneBoundaryHorizontalLine[];
  VerticalLines: ZoneBoundaryVerticalLine[];
}

export interface ProcessedThermalImages {
  Computer: string;
  FrameLocation: number;
  FrameNumber: number;
  Id: string;
  NormalizedImageData: number[][];
  OutlinedImageData: number[][];
  StartDate: string;
  ZoneBoundaryInfo: ThermalImagesZoneBoundaryInfo;
  thermalCalibration: {
    factor: number;
    message: string;
  };
  concerningTemp?: {
    x: number;
    y: number;
    temp: number;
  };
  Hotspots?: ThermalHotspot[];
}

export interface ZoneBoundaryHorizontalLine {
  YStart: number;
  YEnd: number;
  ZoneName: string;
}

export interface ZoneBoundaryVerticalLine {
  XStart: number;
  XEnd: number;
  Clock: number;
}

export interface ProcessedThermalImagesZipped {
  id: string;
  campaignHeatId: string;
  selectedImagesZipped: Uint8Array;
  startTimeUtc: string;
  setId: string;
  computerNumber: number;
  thermalCalibrations: ThermalCalibrationType[];
  concerningTemps: ConcerningTemp[];
}

export interface ConcerningTemp {
  x: number;
  y: number;
  temp: number;
  frameLocation: number;
}

export interface ThermalCalibrationType {
  computer: number;
  frameLocation: number;
  message: string;
  factor: number;
}
